<template>
  <div class="app-container">
    <base-header v-if="showType" activeIndex="3" />

    <div :class="showType ? 'banner__layer' : 'banner__layer bannerss'">

      <img class="banner-img" src="@/assets/imgs/appdownload/banner.png" />
      <img class="banner-imgs" src="@/assets/imgs/appdownload/banners.png" />

      <div :class="showType ? 'banner-content content-box' : 'banner-content content-box banner-co'">
        <h1 class="title">世界 一手掌握</h1>
        <h1 class="titles">世界 </h1>
        <h1 class="titles">一手掌握</h1>
        <p class="banner-content-intro">一机在手 · 指尖盈利</p>
        <div class="banner-content-download">
          <!-- <router-link to="/Appdownload?key=1"> -->
          <span class="banner-content-download-btn" @click="scrollTop">APP下载</span>
          <!-- </router-link> -->
          <div class="banner-content-download-text">
            <div>
              <img src="@/assets/imgs/about/mobie-icon.png" alt="">
              <span>
                支持多平台 <br />
                双端互通
              </span>
            </div>
            <div>
              <img src="@/assets/imgs/about/user-black-icon.png" alt="">
              <span>
                简单 <br />
                易用
              </span>
            </div>
          </div>
        </div>
      </div>

    </div>



    <div class="about-cooperate" ref="targetTop">
      <div class="title__layer">
        <h1 class="title"><span>即刻下载</span> 掌控您的财富先机</h1>
        <h1 class="titles"><span>即刻下载</span></h1>
        <h1 class="titles">掌控您的财富先机</h1>
        <p class="title">智赢未来，开启财富增长新篇章，指尖轻触，商机尽在掌握</p>
        <p class="titles">智赢未来，开启财富增长新篇章</p>
        <p class="titles">指尖轻触，商机尽在掌握</p>
      </div>
      <img class="mt4" src="@/assets/imgs/appdownload/MT4.png" alt="">
      <img class="wapmt4" src="@/assets/imgs/appdownload/MT4.png" alt="">
    </div>
    <BaseDownLoad ref="BaseDownLoadRef" @scrollTop="scrollTop" />

    <base-footer v-if="showType" />
  </div>
</template>

<script>
import BaseHeader from '@/component/base-header';
import BaseFooter from '@/component/base-footer';
import BaseDownLoad from '@/component/base-download';


export default {
  name: 'Index',
  metaInfo: {
    title: '红狮金业官方APP下载|现货黄金白银专业投资软件',
    meta: [
      { name: 'keywords', content: '红狮金业app,贵金属交易软件,贵金属投资APP,现货黄金开户,现货白银,MT4，MT5' },
      { name: 'description', content: '“红狮金业官方APP、MT4/MT5正版交易软件免费下载，适配iOS/Android系统，功能齐全、交易稳定、数据安全，是专业贵金属交易工具。' }
    ]
  },
  components: {
    BaseHeader,
    BaseFooter,
    BaseDownLoad
  },
 
  data() {
    return {
showType:true
    }
  },
  created() {
    if (this.$route.query.from) {
      this.showType = false

    };
    
  },
  mounted() {
    if (this.$route.query.key) {
      setTimeout(() => {
        this.scrollTop()

      }, 100);
    }

  },
  methods: {
    scrollTop(){
      var targetElements = this.$refs.targetTop;
      const targetPosition = targetElements.offsetTop == 50 ? targetElements.offsetTop + 1431 : targetElements.offsetTop + 900;
      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    }
  },
  
}
</script>
<style lang="less" scoped>
.app-container {
  background: #fafafa;

  .content-box {
    width: 1240px;
    margin: auto;
    box-sizing: border-box;
  }

  .banner__layer {
    position: relative;
      // padding-top: 80px;
    .banner-img {
      width: 100%;
      display: block;
    }
    .banner-imgs {
      width: 100%;
      display: none;
    }

    .banner-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 11;
      color: #FFFFFF;
      .title{
        display: block;
      }
      .titles{
        display: none;
      }
      h1 {
        font-size: 68px;
        margin: 0;
      }
      &-intro {
        font-size: 18px;
      }
      &-download {
        display: flex;
        align-items: center;
        margin-top: 50px;

        &-btn {
          width: 198px;
          line-height: 56px;
          color: #FFFFFF;
          background: #FA2314;
          border-radius: 4px;
          margin-right: 10px;
          cursor: pointer;
          text-align: center;
          font-size: 20px;
          font-weight: 700;
          display: inline-block;
        }

        &-text {
          display: flex;
          align-items: center;

          >div {
            display: flex;
            align-items: center;
            color: #FFFFFF;
            padding: 4px 40px;

            &:first-child {
              border-right: 1px solid #0F0F11;
            }

            img {
              width: 38px;
              height: 38px;
              margin-right: 12px;
            }
          }
        }
      }
    }
  }

  .title__layer {
    text-align: center;
    padding: 70px 0 50px;
      .title{
        display: block;
      }
      .titles{
        display: none;
      }
    h1 {
      font-size: 46px;
      margin: 0;
      color: #000;
      margin-bottom: 10px;
      span {
        color: #FA2314;
      }
    }
    p {
      color: #0F0F11;
      font-size: 18px;
    }
  }
  
  .about-intro {
    margin: 100px auto;
    display: flex;
    align-items: center;

    >img {
      width: 452px;
      margin-right: 60px;
    }

    &-right {
      padding: 26px;

      &-title {
        h1 {
          font-size: 46px;
          margin: 0;
          color: #000;
          margin-bottom: 10px;
          span {
            color: #FA2314;
          }
        }
      }

      &-text {
        color: #6d6d6d;
        margin-top: 50px;
        span {
          color: #FA2314;
        }
      }
    }

  }

  .about-standard {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    &-item {
      width: 606px;
      height: 336px;
      color: #FFFFFF;
      margin-bottom: 28px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end; /* 垂直居下 */
      box-sizing: border-box;
      padding: 30px;

      &:first-child {
        background-image: url('../assets/imgs/about/intro-1.png');
        background-size: 100% 100%;
      }

      &:nth-child(2) {
        background-image: url('../assets/imgs/about/intro-2.png');
        background-size: 100% 100%;
      }

      &:nth-child(3) {
        background-image: url('../assets/imgs/about/intro-3.png');
        background-size: 100% 100%;
      }

      &:nth-child(4) {
        background-image: url('../assets/imgs/about/intro-4.png');
        background-size: 100% 100%;
      }

      &-title {
        font-size: 26px;
        font-weight: 700;
      }
      &-line {
        width: 40px;
        height: 4px;
        display: inline-block;
        background: #FA2314;
        margin: 16px 0;
      }
    }
  }

  .about-cooperate {
    background: #FFFFFF;
    margin-top: 50px;
    padding-bottom: 100px;
    text-align: center;
    .mt4{
       display: block;
    }
    .wapmt4{
      display: none;
    }
    >img {
      width: 1132px;
      margin: 0 auto;
    }
  }
}
@media screen and (max-width: 500px) {
  .app-container{
    .banner__layer{
      padding-top: 45px;
        .banner-img{
          display: none;
        }
        .banner-imgs{
          display: block;
          height: 500px;
       
        }
      
      .banner-content {
      position: absolute;
      top: 37%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 11;
      // color: #000;
        color: #FFFFFF;
      padding-top: 40px;
        background: linear-gradient(180deg, #100005 68.28%, rgba(24, 24, 24, 0) 100%);
       .title{
        display: none;
      }
      .titles{
        color: #FFFFFF;
        display: block;
      }
      h1 {
        font-size: 58px;
        line-height: 77px;
        margin: 0;
        width: 100%;
        text-align: center;
        white-space: wrap;
      }
      &-intro {
        font-size: 14px;
        text-align: center;
      }
      &-download {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 20px;

        &-btn {
          width: 180px;
          line-height: 34px;
          color: #FFFFFF;
          background: #FA2314;
          border-radius: 4px;
          margin-right: 10px;
          cursor: pointer;
          text-align: center;
          font-size: 14px;
          font-weight: 700;
          margin-bottom: 20px;
        }

        &-text {
          display: flex;
          align-items: center;

          >div {
            display: flex;
            align-items: center;
            color: #0F0F11;
          color: #FFFFFF;

            padding: 2px 20px;
            font-size: 10px;
            &:first-child {
              border-right: 1px solid #fff;
            }

            img {
              width: 24px;
              height: 24px;
              margin-right: 12px;
            }
          }
        }
      }
    }
        .banner-co {
          top: 33%;
        }
        }
    
        .bannerss {
          padding-top: 0;
        }
    .content-box {
      width: 100%;
      margin: auto;
      box-sizing: border-box;
    }
    .title__layer {
      .title{
        display: none;
      }
      .titles{
        display: block;
      }
      h1{
        font-size: 36px;
        line-height: 48px;
      }
      p{
        font-size: 14px;
      }
    }
    .about-cooperate {
    
    .mt4{
       display: none;
    }
    .wapmt4{
      display: block;
      width: 100%;
    }
  }
  }
}
 // -------------------------小屏幕适配-------------------
 @media screen and (min-width: 1264px) and (max-width: 1724px) {
  .app-container {
      background: #fafafa;
  
      .content-box {
        width: 1000px;
        margin: auto;
        box-sizing: border-box;
      }
  
      .banner__layer {
        position: relative;
        // padding-top: 80px;
  
        .banner-img {
          width: 100%;
          display: block;
        }
  
        .banner-imgs {
          width: 100%;
          display: none;
        }
  
        .banner-content {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 11;
          color: #FFFFFF;
  
          .title {
            display: block;
          }
  
          .titles {
            display: none;
          }
  
          h1 {
            font-size: 50px;
            margin: 0;
          }
  
          &-intro {
            font-size: 18px;
          }
  
          &-download {
            display: flex;
            align-items: center;
            margin-top: 50px;
  
            &-btn {
              width: 198px;
              line-height: 56px;
              color: #FFFFFF;
              background: #FA2314;
              border-radius: 4px;
              margin-right: 10px;
              cursor: pointer;
              text-align: center;
              font-size: 20px;
              font-weight: 700;
              display: inline-block;
            }
  
            &-text {
              display: flex;
              align-items: center;
  
              >div {
                display: flex;
                align-items: center;
                color: #FFFFFF;
                padding: 4px 40px;
  
                &:first-child {
                  border-right: 1px solid #0F0F11;
                }
  
                img {
                  width: 38px;
                  height: 38px;
                  margin-right: 12px;
                }
              }
            }
          }
        }
      }
  
      .title__layer {
        text-align: center;
        padding: 70px 0 50px;
  
        .title {
          display: block;
        }
  
        .titles {
          display: none;
        }
  
        h1 {
          font-size: 46px;
          margin: 0;
          color: #000;
          margin-bottom: 10px;
  
          span {
            color: #FA2314;
          }
        }
  
        p {
          color: #0F0F11;
          font-size: 18px;
        }
      }
  
      .about-intro {
        margin: 100px auto;
        display: flex;
        align-items: center;
  
        >img {
          width: 452px;
          margin-right: 60px;
        }
  
        &-right {
          padding: 26px;
  
          &-title {
            h1 {
              font-size: 46px;
              margin: 0;
              color: #000;
              margin-bottom: 10px;
  
              span {
                color: #FA2314;
              }
            }
          }
  
          &-text {
            color: #6d6d6d;
            margin-top: 50px;
  
            span {
              color: #FA2314;
            }
          }
        }
  
      }
  
      .about-standard {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
  
        &-item {
          width: 606px;
          height: 336px;
          color: #FFFFFF;
          margin-bottom: 28px;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          /* 垂直居下 */
          box-sizing: border-box;
          padding: 30px;
  
          &:first-child {
            background-image: url('../assets/imgs/about/intro-1.png');
            background-size: 100% 100%;
          }
  
          &:nth-child(2) {
            background-image: url('../assets/imgs/about/intro-2.png');
            background-size: 100% 100%;
          }
  
          &:nth-child(3) {
            background-image: url('../assets/imgs/about/intro-3.png');
            background-size: 100% 100%;
          }
  
          &:nth-child(4) {
            background-image: url('../assets/imgs/about/intro-4.png');
            background-size: 100% 100%;
          }
  
          &-title {
            font-size: 26px;
            font-weight: 700;
          }
  
          &-line {
            width: 40px;
            height: 4px;
            display: inline-block;
            background: #FA2314;
            margin: 16px 0;
          }
        }
      }
  
      .about-cooperate {
        background: #FFFFFF;
        margin-top: 50px;
        padding-bottom: 100px;
        text-align: center;
  
        .mt4 {
          display: block;
        }
  
        .wapmt4 {
          display: none;
        }
  
        >img {
          width: 1000px;
          margin: 0 auto;
        }
      }
    }
 }
</style>